import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Loading from "../components/Loading";
import StatisticDetailTable from "../components/StatisticDetailTable";
import http from "../services/http";

const StatisticConstructionDetail = () => {
  const [detailList, setDetailList] = useState([]);
  const [constructionInfo, setConstructionInfo] = useState({});
  const [isLoading, setLoading] = useState(false);

  const { id, year, month } = useParams();

  const fetchConstructionDetail = async () => {
    setLoading(true);
    try {
      const response = await http.get(
        `auth/statistic/constructionWork/detailList?year=${year}&month=${month}&constructionWorkID=${id}`
      );
      if (response) {
        setDetailList(response);
      }
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  const fetchConstructionInfo = async () => {
    setLoading(true);
    try {
      const response = await http.get(`auth/constructionWork/info?id=${id}`);
      if (response) {
        setConstructionInfo(response);
      }
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchConstructionInfo();
    fetchConstructionDetail();
  }, []);

  return (
    <div className="w-full">
      {isLoading && <Loading />}
      <div className="mx-10 mt-10 text-5xl font-bold">
        工程案收支統計-{constructionInfo.name}
      </div>
      <StatisticDetailTable year={year} month={month} detailList={detailList} />
    </div>
  );
};

export default StatisticConstructionDetail;
